import { useState } from 'react';

import { Button, Input, Modal } from '@/components/ui';

/**
 * Ask for the reason a student document is refused. The student is shown it,
 * so it should say what to fix. The backend asks for four characters.
 *
 * `onSubmit(reason)` returns a promise; the modal clears and closes once it
 * resolves.
 */
export function RejectReasonModal({ open, title, placeholder, isLoading, onClose, onSubmit }) {
  const [reason, setReason] = useState('');

  function close() {
    setReason('');
    onClose();
  }

  async function submit() {
    try {
      await onSubmit(reason.trim());
      close();
    } catch {
      // The caller's mutation already toasted the error; keep the text.
    }
  }

  return (
    <Modal
      open={open}
      title={title}
      description="The student is told the reason and can upload a new copy. It is recorded in the audit log."
      onClose={close}
      footer={
        <>
          <Button variant="secondary" onClick={close}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={reason.trim().length < 4}
            isLoading={isLoading}
            onClick={() => void submit()}
          >
            Reject
          </Button>
        </>
      }
    >
      <Input
        label="Reason"
        required
        placeholder={placeholder}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
    </Modal>
  );
}
